export class UnavailabilityData {
    constructor(arg) {
        Object.assign(this, arg);
        this.date = new Date(this.date);
        this.start = new Date(this.start);
        this.end = new Date(this.end);
    }
}
export var UnavailabilityReason;
(function (UnavailabilityReason) {
    UnavailabilityReason[UnavailabilityReason["None"] = 0] = "None";
    UnavailabilityReason[UnavailabilityReason["Holiday"] = 1] = "Holiday";
    UnavailabilityReason[UnavailabilityReason["Sickness"] = 2] = "Sickness";
    UnavailabilityReason[UnavailabilityReason["Other"] = 99] = "Other";
})(UnavailabilityReason || (UnavailabilityReason = {}));
